import React from 'react';
import { Bell, Search } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { Globe } from 'lucide-react';

const Header: React.FC = () => {
  const { user, logout, currentFlavourId, availableFlavours } = useAuth();

  const isSuperAdmin = user?.role === 'super_admin';
  const isAdmin = user?.role === 'admin';
  const isSubAdmin = user?.role === 'sub_admin';

  const filteredFlavours = React.useMemo(() => {
    if (isSuperAdmin) {
      // Super admin can see all apps
      return availableFlavours;
    } else if (isAdmin || isSubAdmin) {
      // Admin/Sub-admin can only see apps they're assigned to
      if (user?.flavourIds && user.flavourIds.length > 0) {
        return availableFlavours.filter(flavour =>
          user.flavourIds!.includes(parseInt(flavour.id))
        );
      }
      return [];
    }
    return [];
  }, [availableFlavours, user, isSuperAdmin, isAdmin, isSubAdmin]);
  const currentApp = filteredFlavours.find(f => f.id === currentFlavourId) || filteredFlavours?.[0];

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-1 h-16">
      <div className="flex items-center justify-between">
        {/* Search */}
        {/* <div className="flex-1 max-w-lg">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            <input
              type="text"
              placeholder="Search..."
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
            />
          </div>
        </div> */}
        {currentApp && (
        <div className="px-4 py-2">
          <div className="flex items-center space-x-3">
            <Globe className="w-4 h-4 text-primary" />
            <div className="flex-1 min-w-0">
              <p className="text-m font-medium text-gray-900 truncate">
                {currentApp.name}
              </p>
              {currentApp.description && (
                <p className="text-xs text-gray-500 truncate">
                  {currentApp.description}
                </p>
              )}
            </div>
          </div>
        </div>
      )}

        {/* Right side */}
        <div className="flex items-center space-x-4">

          {/* User menu */}
          <div className="flex items-center space-x-3">
            <div className="text-right">
              <p className="text-sm font-medium text-gray-900">
                {user?.firstName} {user?.lastName}
              </p>
              <p className="text-xs text-gray-500">{user?.role || 'Administrator'}</p>
            </div>
            <div className="h-8 w-8 rounded-full bg-primary-100 flex items-center justify-center">
              <span className="text-sm font-medium text-primary-700">
                {user?.firstName?.charAt(0) || user?.email?.charAt(0) || 'U'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header; 